import React, { Fragment } from 'react';
import { DocumentsLandingPres } from '../presentational';

export class DocumentsContainer extends React.Component {
  render() {
    return (
      <Fragment>
        <DocumentsLandingPres />
      </Fragment>
    );
  }
}

export default DocumentsContainer;
